import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LangDetail } from 'ngx-core-services';
import { map, startWith } from 'rxjs/operators';

import { supportedLanguages } from '../utils/constants';
import { RefreshService } from './refresh.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  readonly languages: LangDetail[] = supportedLanguages;
  readonly currentLang$ = this.translateService.onLangChange.pipe(
    startWith(this.languages.find((lang) => lang.id === (this.translateService.currentLang || this.translateService.defaultLang))),
    map(() => this.languages.find((lang) => lang.id === (this.translateService.currentLang || this.translateService.defaultLang))),
  );

  constructor(
    readonly translateService: TranslateService,
    readonly refreshService: RefreshService,
  ) { }

  async changeLanguage(language: string) {
    this.translateService.use(language);
    localStorage.setItem('language', language);
    this.refreshService.refresh$.next();
  }
}
